import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../../../components/Button';
import FontAwesomeIcon from '../../../components/Icon';
import { isRole } from 'src/helpers/permissions';
import { USER_ROLES } from 'src/common/constants';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

interface ManageVisibilityButtonProps {
  onClick: () => void;
}

const ManageVisibilityButton = ({ onClick }: ManageVisibilityButtonProps) => {
  const user = useSelector(selectAuthenticatedUser);

  const canManageVisibility: boolean = isRole(
    [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.PROPERTY_DEVELOPER],
    user
  );

  if (!canManageVisibility) {
    return null;
  }

  return (
    <Button
      color="teal"
      label="Manage Visibility"
      size="small"
      onClick={onClick}
      icon={<FontAwesomeIcon glyph="eye-slash" weight="light" size="small" />}
      outlined={true}
      block={undefined}
      disabled={undefined}
      outline={undefined}
      weight={undefined}
      children={undefined}
      style={undefined}
      hideLabel={false}
      id="serviceRequestManageVisibilityButton"
    />
  );
};

export default ManageVisibilityButton;